import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-lid-card-mobile',
  templateUrl: './lid-card-mobile.component.html',
  styleUrls: ['./lid-card-mobile.component.scss']
})
export class LidCardMobileComponent implements OnInit {

  @Input()
  currentLid
  @Input()
  columns
  @Output() onViewDetails: EventEmitter<any> = new EventEmitter<any>()
  constructor() { }

  ngOnInit(): void {
    console.log(this.currentLid)
  }
  viewRowDetails(itemId, selectedRow) {
    this.onViewDetails.emit({ itemId, selectedRow })
  }
}
